import { SupplierRegistrationCountryFields } from '@supplierRegistration/domain/supplierRegistrationCountryFields';

export const MY: SupplierRegistrationCountryFields = {
  additionalCompanyName: true,
};
